export const workplaceQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "The monitors have been turned on.",
      B: "Books have been stacked neatly on the desk.",
      C: "The office space is divided by partitions.",
      D: "The blinds have been closed.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '사무실 공간이 파티션으로 나누어져 있다' → 사무실에 파티션이 설치되어 있음\n\n오답 설명:\n\n(A) '모니터가 켜져 있다' → 모니터가 꺼져 있음,\n\n(B) '책이 책상 위에 깔끔하게 쌓여있다' → 책상 위에 책이 보이나 깔끔히 쌓여있는 모습은 없음,\n\n(D) '블라인드가 닫혀있다' → 블라인드가 안보임",
  },
  {
    questionNumber: 2,
    choices: {
      A: "The desk is being organized.",
      B: "The desks have been cleared.",
      C: "The desk is cluttered with office supplies.",
      D: "The documents have been neatly arranged.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '책상이 사무용품들로 어수선하다' → 책상 위에 사무용품들이 어지럽게 놓여있음\n\n오답 설명:\n\n(A) '책상이 정리되어지는 중이다' → 책상을 정리하는 사람이 보이지 않음,\n\n(B) '책상이 깨끗이 치워져 있다' → 책상 위가 어수선함,\n\n(D) '서류가 깔끔하게 정리되어 있다' → 책상 위에 서류가 어지럽게 놓여있음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "A container on the desk is empty.",
      B: "A computer screen is displaying a document.",
      C: "Some papers are scattered across the desk.",
      D: "A desk is neatly organized.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '책상이 깔끔하게 정리되어 있다' → 책상이 정돈된 상태로 보임\n\n오답 설명:\n\n(A) '책상 위의 컨테이너가 비어있다' → 컨테이너가 연필로 가득 차 있음,\n\n(B) '컴퓨터 화면에 문서가 표시되어 있다' → 화면이 보이지 않음,\n\n(C) '책상 위에 서류들이 흩어져 있다' → 책상 위에 문서가 없음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "The drawer has been pushed in.",
      B: "A printer is sitting on the desk.",
      C: "The computer monitor is turned off.",
      D: "The chair is occupied.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '컴퓨터 모니터가 꺼져있다' → 모니터 화면이 꺼져있음\n\n오답 설명:\n\n(A) '서랍이 밀어 넣어져 있다' → 서랍 하나가 열려있음,\n\n(B) '프린터가 책상 위에 있다' → 프린터는 수납장/서랍장 위에 있음,\n\n(D) '의자에 사람이 앉아있다' → 의자가 비어있음",
  },
  {
    questionNumber: 5,
    choices: {
      A: "The curtains are drawn.",
      B: "The chair is occupied.",
      C: "A telephone is placed on the desk.",
      D: "The chair has been pushed under the desk.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '전화기가 책상 위에 놓여있다' → 책상 위에 전화기가 놓여있음\n\n오답 설명:\n\n(A) '커튼이 쳐져있다' → 커튼이 걷혀있음,\n\n(B) '의자에 사람이 앉아있다' → 의자가 비어 있음,\n\n(D) '의자가 책상 아래로 밀어 넣어져 있다' → 의자가 책상 옆에 있음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "A projector is hanging from the ceiling.",
      B: "The office is occupied.",
      C: "The office furniture is being set up.",
      D: "Several monitors are lined up on the desks.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '여러 대의 모니터가 책상 위에 나란히 놓여있다' → 책상 위에 모니터들이 일렬로 설치되어 있음\n\n오답 설명:\n\n(A) '천장에 프로젝터가 달려있다' → 천장에 조명이 있지만 프로젝터는 없음,\n\n(B) '사무실이 사용 중이다' → 사무실 사용하는 사람이 없음,\n\n(C) '사무실 가구들이 설치되어지는 중이다' → 책상과 의자 등 가구들이 이미 설치되어 있고 설치하는 사람도 보이지 않음",
  },
  {
    questionNumber: 7,
    choices: {
      A: "The blinds are shut.",
      B: "A conference table is surrounded by chairs.",
      C: "The meeting is in progress.",
      D: "A whiteboard is mounted on the wall.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '회의 테이블이 의자들로 둘러싸여 있다' → 회의실 테이블 주변에 의자들이 배치되어 있음\n\n오답 설명:\n\n(A) '블라인드가 닫혀있다' → 블라인드가 부분적으로만 내려와 있음,\n\n(C) '회의가 진행 중이다' → 회의실은 있지만 회의 하는 사람이 없음,\n\n(D) '벽에 화이트보드가 설치되어 있다' → 벽에 화이트보드가 없음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "The desks have been arranged against the wall.",
      B: "The blinds have been fully raised.",
      C: "Chairs are lined up along the desks.",
      D: "A meeting is taking place in the conference room.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '의자들이 책상을 따라 일렬로 놓여있다' → 책상을 따라 의자들이 일렬로 배치되어 있음\n\n오답 설명:\n\n(A) '책상이 벽을 따라 배치되어 있다' → 책상이 창문을 따라 놓여있음,\n\n(B) '블라인드가 완전히 올려져 있다' → 블라인드가 일부 내려와 있음,\n\n(D) '회의실에서 회의가 진행되고 있다' → 회의실이 있지만 사람이 없음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "A chair is occupied at one of the desks.",
      B: "Some telephones are placed on the desks.",
      C: "Some papers are spread out on the desks.",
      D: "Partitions are separating the desks.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '파티션이 책상들을 구분하고 있다' → 사무실 공간이 파티션으로 분리되어 있음\n\n오답 설명:\n\n(A) '책상 중 하나에 사람이 앉아있다' → 의자가 있지만 사람이 없음,\n\n(B) '전화기가 책상 위에 놓여있다' → 전화기가 있지만 모든 책상 위에 있는 것은 아님,\n\n(C) '서류들이 책상 위에 펼쳐져 있다' → 책상에 서류들이 보이지 않음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "The office walls are decorated with potted plants.",
      B: "The computer is being placed.",
      C: "Computers have been set up on the desks.",
      D: "The trash bins are overflowing with waste.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '컴퓨터가 책상 위에 설치되어 있다' → 책상마다 컴퓨터가 설치되어 있음\n\n오답 설명:\n\n(A) '사무실 벽이 화분으로 장식되어 있다' → 화분은 각 파티션이 겹치는 곳에 놓여져 있음,\n\n(B) '컴퓨터가 설치되어지는 중이다' → 컴퓨터는 이미 설치되어 있음,\n\n(D) '쓰레기통이 쓰레기로 가득 차 있다' → 휴지통이 있지만 깨끗한 상태",
  },

  {
    questionNumber: 11,
    choices: {
      A: "The potted plants are being placed.",
      B: "Some computers have been arranged on the desks.",
      C: "Some employees are having a discussion.",
      D: "The blinds have been completely closed.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '컴퓨터가 책상 위에 배치되어 있다' → 책상마다 컴퓨터가 설치되어 있음\n\n오답 설명:\n\n(A) '화분이 놓여지는 중이다' → 화분은 이미 위치해 있는 상태임,\n\n(C) '직원들이 토론을 하고 있다' → 사무실에는 사람이 없음,\n\n(D) '블라인드가 완전히 닫혀있다' → 창문에는 블라인드가 없음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "Curtains are drawn over the windows.",
      B: "The chairs are being arranged.",
      C: "The ceiling lights are being installed.",
      D: "Monitors have been placed on the desks.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '모니터가 책상 위에 놓여있다' → 책상마다 모니터가 설치되어 있음\n\n오답 설명:\n\n(A) '창문에 커튼이 쳐져있다' → 창문이 있지만 커튼이 없음,\n\n(B) '의자들이 놓여지는 중이다' → 의자를 놓고 있는 사람이 보이지 않음,\n\n(C) '천장조명이 설치되어지는 중이다' → 설치하는 사람이 보이지 않음",
  },
  {
    questionNumber: 13,
    choices: {
      A: "The binders are being arranged on the shelves.",
      B: "Books have been arranged on a shelf.",
      C: "The cabinet doors have been opened.",
      D: "The desk lamp is being installed.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '책들이 책장에 정리되어 있다' → 책장에 책들이 정돈되어 있음\n\n오답 설명:\n\n(A) '선반 위 바인더들이 정렬되어지는 중이다' → 파일 정렬하고 있는 사람이 안보임,\n\n(C) '수납장 문이 열려져 있다' → 수납장 문은 다 닫혀있는 상태,\n\n(D) '책상 조명이 설치되어지는 중이다' → 조명은 이미 설치되어 있는 상태",
  },
  {
    questionNumber: 14,
    choices: {
      A: "The office is being cleaned.",
      B: "A stack of papers has been placed on the floor.",
      C: "A jacket has been hung over a chair.",
      D: "The printer is being used.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '재킷이 의자에 걸려있다' → 의자에 재킷이 걸려있는 것이 보임\n\n오답 설명:\n\n(A) '사무실이 청소되고 있다' → 청소하는 사람이 보이지 않음,\n\n(B) '서류 뭉치가 바닥에 놓여있다' → 문서트레이가 책상 위에는 있지만 바닥에는 없음,\n\n(D) '프린터로 문서를 출력하고 있다' → 프린터가 있지만 사용하는 사람이 없음",
  },
  {
    questionNumber: 15,
    choices: {
      A: "A screen is being installed.",
      B: "Some seats are occupied.",
      C: "An overhead projector is mounted on the ceiling.",
      D: "A projector has been placed in front of the screen.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '프로젝터가 스크린 앞에 놓여있다' → 스크린 앞에 프로젝터가 설치되어 있음\n\n오답 설명:\n\n(A) '스크린이 설치되는 중이다' → 스크린이 이미 설치되어 있음,\n\n(B) '일부 좌석이 사용 중이다' → 좌석이 모두 비어 있음,\n\n(C) '천장형 프로젝터가 천장에 설치되어 있다' → 프로젝터는 있지만 천장에 설치되어 있지 않음",
  },
  {
    questionNumber: 16,
    choices: {
      A: "A presentation is being displayed on the screen.",
      B: "A conference phone has been placed on the table.",
      C: "Some documents have been spread across the table.",
      D: "The chairs are fully occupied.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '회의용 전화기가 테이블 위에 놓여있다' → 테이블 위에 회의용 전화기가 설치되어 있음\n\n오답 설명:\n\n(A) '프레젠테이션이 스크린에 표시되고 있다' → 화면이 꺼져 있음,\n\n(C) '문서들이 테이블 위에 펼쳐져 있다' → 테이블 위에 문서가 없음,\n\n(D) '의자가 모두 사용 중이다' → 의자가 있지만 사람이 앉아 있지 않음",
  },
  {
    questionNumber: 17,
    choices: {
      A: "A projector is being placed on the desk.",
      B: "The blinds have been drawn over the windows.",
      C: "Ceiling lights are hanging from the ceiling.",
      D: "The screen is being lowered.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '천장등이 천장에 매달려 있다' \n\n오답 설명:\n\n(A) '프로젝터가 책상 위에 놓여지는 중이다' → 프로젝터는 이미 책상에 놓여져 있음,\n\n(B) '블라인드가 창문을 가리고 있다' → 창문이 있지만 블라인드가 내려와 있지 않음,\n\n(D) '스크린이 내려오는 중이다' → 스크린은 이미 다 내려와 있는 상태임",
  },
  {
    questionNumber: 18,
    choices: {
      A: "A man is working on his laptop at the table.",
      B: "A bookshelf is filled with documents and binders.",
      C: "A glass door has been left open.",
      D: "A meeting is in progress in the conference room.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '유리문이 열려있다' → 사진에서 유리문이 열려있는 것이 확실히 보임\n\n오답 설명:\n\n(A) '한 남자가 테이블에서 노트북으로 작업하고 있다' → 사진에 사람이 없음,\n\n(B) '책장이 문서와 바인더로 가득 차 있다' → 선반에 책이 있지만 문서와 바인더로 가득 차 있지는 않음,\n\n(D) '회의실에서 회의가 진행 중이다' → 회의실에 사람이 없어 회의가 진행되고 있지 않음",
  },
  {
    questionNumber: 19,
    choices: {
      A: "A man is fixing a broken printer.",
      B: "A stack of documents is being placed on a desk.",
      C: "A person is making a copy using a printer.",
      D: "The printer is out of paper.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '한 사람이 프린터를 사용하여 복사를 하고 있다' → 손의 위치와 프린터의 형태를 고려했을 때 확실한 정답\n\n오답 설명:\n\n(A) '한 남자가 고장난 프린터를 수리하고 있다' → 프린터는 정상적으로 작동 중이며, 수리하는 장면이 아님,\n\n(B) '서류 뭉치가 책상 위에 놓이고 있다' → 프린터 안에 용지가 있지만, 책상 위에 놓이는 장면은 아님,\n\n(D) '프린터에 용지가 떨어졌다' → 프린터에 용지가 있음",
  },
  {
    questionNumber: 20,
    choices: {
      A: "Paper is being loaded into the printer.",
      B: "A copier has been left open.",
      C: "A person is waiting for a document to be printed.",
      D: "A fax machine is receiving an incoming document.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '복사기 덮개가 열려있다' → 복사기의 덮개가 열려있는 것이 명확하게 보임\n\n오답 설명:\n\n(A) '프린터에 용지가 로딩되고 있다' → 용지를 넣는 사람이나 동작이 보이지 않음,\n\n(C) '한 사람이 문서가 프린트되기를 기다리고 있다' → 사진에 사람이 없음,\n\n(D) '팩스기가 문서를 수신하고 있다' → 팩스 수신 여부를 확인할 수 없음",
  },
  {
    questionNumber: 21,
    choices: {
      A: "Several boxes are stacked in the room.",
      B: "Boxes are being packed in the room.",
      C: "A bookshelf is filled with books.",
      D: "Some clothes are neatly folded on a bed.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '여러 개의 박스가 방 안에 쌓여있다' → 사진 속 박스들이 여러 개 쌓여 있는 것이 명확하게 보임\n\n오답 설명:\n\n(B) '박스들이 방 안에서 포장되고 있다' → 박스는 있지만 실제로 포장하는 모습은 보이지 않음,\n\n(C) '책장이 책으로 가득 차 있다' → 사진에 책장이 없으며 책이 가득 찬 모습도 보이지 않음,\n\n(D) '옷이 침대 위에 깔끔하게 접혀있다' → 옷은 있지만 침대 위에 깔끔하게 접혀있지 않음",
  },
  {
    questionNumber: 22,
    choices: {
      A: "A janitor is cleaning the floor.",
      B: "A restroom door is being propped open.",
      C: "A mop and bucket have been placed inside the restroom.",
      D: "A cleaning cart is parked in the hallway.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '청소 카트가 복도에 주차되어 있다' → 사진 속 복도에 청소 카트가 멈춰 있는 것이 명확하므로 반박할 수 없는 정답\n\n오답 설명:\n\n(A) '청소부가 바닥을 청소하고 있다' → 청소 도구가 있지만, 실제로 청소하는 사람이 보이지 않음,\n\n(B) '화장실 문이 열려있다' → 화장실 입구는 보이지만 문이 열려 있는 것이 아니라 닫혀 있음,\n\n(C) '대걸레와 양동이가 화장실 안에 놓여있다' → 청소 도구는 화장실 안이 아니라 밖에 있음",
  },
  {
    questionNumber: 23,
    choices: {
      A: "A rectangular table is placed in the center of the room.",
      B: "A projector screen is hanging on the wall.",
      C: "A notepad and some pens are arranged on the table.",
      D: "Several office chairs are arranged around a table.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '여러 개의 사무용 의자가 테이블 주위에 배치되어 있다' → 사진 속에 여러 개의 사무용 의자가 원형 테이블 주위에 배치되어 있는 것이 명확히 보임\n\n오답 설명:\n\n(A) '직사각형 테이블이 방 중앙에 놓여있다' → 테이블이 둥근(원형) 형태이므로 오답,\n\n(B) '프로젝터 스크린이 벽에 걸려있다' → 벽은 보이지만 프로젝터 스크린은 없음,\n\n(C) '메모장과 펜이 테이블 위에 놓여있다' → 테이블 위에 아무런 물건도 없음",
  },
  {
    questionNumber: 24,
    choices: {
      A: "A clock is hanging against the wall.",
      B: "A medical consultation is taking place.",
      C: "Several chairs are placed against the wall.",
      D: "The floor is covered with a carpet.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '여러 개의 의자가 벽에 기대어 놓여있다' → 사진 속 의자들이 벽에 기대어 배치되어 있는 것이 명확히 보임\n\n오답 설명:\n\n(A) '시계가 벽에 걸려있다' → 벽에 시계가 보이지 않음,\n\n(B) '의료 상담이 진행되고 있다' → 병원처럼 보이지만 의사와 환자가 보이지 않음,\n\n(D) '바닥이 카펫으로 덮여있다' → 바닥이 타일로 되어 있음",
  },
  {
    questionNumber: 25,
    choices: {
      A: "A person is editing a video on a computer.",
      B: "A notebook is placed next to a stack of books.",
      C: "A large window is letting sunlight into the room.",
      D: "Multiple monitors are set up on a desk.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '여러 개의 모니터가 책상 위에 설치되어 있다' → 사진 속 책상 위에 여러 대의 모니터가 설치되어 있는 것이 명확히 보임\n\n오답 설명:\n\n(A) '한 사람이 컴퓨터로 영상을 편집하고 있다' → 컴퓨터와 카메라는 있지만 실제로 작업하는 사람이 보이지 않음,\n\n(B) '노트북이 책 더미 옆에 놓여있다' → 노트북은 있지만 책들이 쌓여있는 모습은 보이지 않음,\n\n(C) '큰 창문으로 햇빛이 방 안으로 들어오고 있다' → 실내가 어둡고 창문이 보이지 않음",
  },
  {
    questionNumber: 26,
    choices: {
      A: "Some books have been placed on the round table.",
      B: "A transparent partition separates the tables.",
      C: "A chair is being pulled out.",
      D: "Some chairs are stacked in the corner of the room.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '투명한 칸막이가 테이블들을 구분하고 있다' → 사진 속 테이블들이 투명한 칸막이로 구분되어 있는 것이 명확히 보임\n\n오답 설명:\n\n(A) '책들이 둥근 테이블 위에 놓여있다' → 테이블은 둥글지만 위에 아무것도 놓여있지 않음,\n\n(C) '의자가 당겨지고 있다' → 의자는 있지만 실제로 누군가 당기는 모습은 보이지 않음,\n\n(D) '의자들이 방 구석에 쌓여있다' → 의자들이 개별적으로 놓여있을 뿐 쌓여있지 않음",
  },
  {
    questionNumber: 27,
    choices: {
      A: "A newspaper has been placed on the table.",
      B: "A man is sitting on one of the chairs.",
      C: "Two chairs are facing each other with a table in between.",
      D: "A lamp is standing next to the chairs.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '두 개의 의자가 테이블을 사이에 두고 마주보고 있다' → 사진 속에서 두 개의 의자가 마주 보고 있으며, 가운데 테이블이 있으므로 정확한 정답\n\n오답 설명:\n\n(A) '신문이 테이블 위에 놓여있다' → 사진 속 테이블에는 아무것도 놓여 있지 않음,\n\n(B) '한 남자가 의자 중 하나에 앉아있다' → 의자가 있지만 사람이 없음,\n\n(D) '램프가 의자들 옆에 서있다' → 식물이 보이지만, 램프는 없음",
  },
  {
    questionNumber: 28,
    choices: {
      A: "Several pendant lights are hanging from the ceiling.",
      B: "A projector is being used for a presentation.",
      C: "Some papers have been spread out on the table.",
      D: "People are taking seats around the table.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '여러 개의 펜던트 조명이 천장에서 매달려 있다' → 사진 속 천장에서 여러 개의 펜던트 조명이 매달려 있으므로 반박할 수 없는 정답\n\n오답 설명:\n\n(B) '프로젝터로 프레젠테이션이 진행되고 있다' → 회의실에는 스크린이 있지만, 실제로 프로젝터가 사용되고 있는 모습은 없음,\n\n(C) '서류들이 테이블 위에 펼쳐져 있다' → 책상 위에는 아무런 문서가 없음,\n\n(D) '사람들이 테이블 주변에 자리를 잡고 있다' → 의자가 있지만 사람이 없음",
  },
  {
    questionNumber: 29,
    choices: {
      A: "Several rows of chairs are placed against the wall.",
      B: "A group of people is waiting in the hallway.",
      C: "The floor is being mopped.",
      D: "Some posters are hanging on the wall.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '여러 줄의 의자가 벽에 기대어 놓여있다' → 사진 속 의자들이 벽에 기대어 줄지어 배치되어 있으므로 유일한 정답\n\n오답 설명:\n\n(B) '사람들이 복도에서 기다리고 있다' → 대기 의자는 있지만 사람이 없음,\n\n(C) '바닥을 닦고 있다' → 바닥이 깨끗해 보이지만 실제로 청소하는 사람이 없음,\n\n(D) '포스터들이 벽에 걸려있다' → 벽에 문과 표지판은 있지만 포스터는 보이지 않음",
  },
  {
    questionNumber: 30,
    choices: {
      A: "A security guard is checking visitors at the entrance.",
      B: "Some people are sitting on a bench outside the building.",
      C: "A large sign is displayed above the entrance.",
      D: "A revolving door is located at the entrance.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '회전문이 입구에 위치해 있다' → 사진 속 건물 입구에 회전문이 설치되어 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '경비원이 입구에서 방문객들을 확인하고 있다' → 건물 입구는 보이지만 경비원이 없음,\n\n(B) '몇 명의 사람들이 건물 밖 벤치에 앉아있다' → 건물 외부가 보이지만 벤치에 앉아있는 사람이 없음,\n\n(C) '큰 간판이 입구 위에 설치되어 있다' → 입구에 작은 표지판은 있지만 큰 간판은 없음",
  },
  {
    questionNumber: 31,
    choices: {
      A: "The desks are occupied.",
      B: "A printer is placed in the middle of the office.",
      C: "A pile of books is stacked on the desk.",
      D: "A long light fixture is suspended from the ceiling.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '긴 조명이 천장에서 매달려 있다' → 사진 속 천장에서 긴 조명이 매달려 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '책상이 사용 중이다' → 책상이 있지만 사람이 없음,\n\n(B) '프린터가 사무실 중앙에 놓여있다' → 사무실이지만 프린터는 보이지 않음,\n\n(C) '책들이 책상 위에 쌓여있다' → 책상 위에 컴퓨터와 서류 정리함은 있지만 책은 없음",
  },
  {
    questionNumber: 32,
    choices: {
      A: "The clocks on the wall are being adjusted.",
      B: "The reception desk is being used.",
      C: "The chairs are facing each other.",
      D: "Several clocks are mounted on the wall.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '여러 개의 시계가 벽에 부착되어 있다' → 사진 속 벽에 여러 개의 시계가 부착되어 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '벽에 있는 시계들이 조정되고 있다' → 벽에 시계가 있지만 조정하는 사람이 없음,\n\n(B) '리셉션 데스크가 사용되고 있다' → 책상이 있지만 실제로 사용하는 사람이 없음,\n\n(C) '의자들이 서로 마주보고 있다' → 의자가 있지만 같은 방향을 보고 있음",
  },
  {
    questionNumber: 33,
    choices: {
      A: "Some employees are working at their desks.",
      B: "A meeting is taking place in the office.",
      C: "Several cubicles are arranged in rows.",
      D: "A trash bin is placed in the center of the room.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '여러 개의 큐비클이 줄지어 배치되어 있다' → 사진 속 여러 개의 큐비클이 줄지어 배치되어 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '직원들이 책상에서 일하고 있다' → 사무실이지만 직원들이 보이지 않음,\n\n(B) '사무실에서 회의가 진행되고 있다' → 사무 공간이지만 회의가 진행되고 있는 모습은 없음,\n\n(D) '쓰레기통이 방 중앙에 놓여있다' → 쓰레기통이 있지만 방 중앙이 아닌 구석에 놓여 있음",
  },
  {
    questionNumber: 34,
    choices: {
      A: "A person is typing on a laptop.",
      B: "A desk lamp has been turned on.",
      C: "Several books are propped up.",
      D: "A picture frame is being hung on the wall.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '여러 권의 책이 기대어 놓여있다' → 사진 속 책들이 기대어 놓여있으므로 유일한 정답\n\n오답 설명:\n\n(A) '한 사람이 노트북으로 타이핑을 하고 있다' → 책상 위에 노트북이 있지만 사람이 없음,\n\n(B) '책상 스탠드가 켜져있다' → 책상에 스탠드가 있지만 불이 켜져 있지 않음,\n\n(D) '액자가 벽에 걸리고 있다' → 벽에 액자가 있지만 걸고 있는 사람이 없음",
  },
  {
    questionNumber: 35,
    choices: {
      A: "Some people are engaged in a discussion.",
      B: "A potted plant is placed in the center of the table.",
      C: "Some charts are displayed on a whiteboard.",
      D: "A stack of chairs is pushed against the wall.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '화이트보드에 차트가 부착되어 있다' → 사진 속 화이트보드에 차트가 부착되어 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '몇 명의 사람들이 토론을 하고 있다' → 책상과 회의실처럼 보이지만 사람이 없음,\n\n(B) '화분이 테이블 중앙에 놓여있다' → 책상 위에 다양한 사무용품이 있지만 화분은 없음,\n\n(D) '의자들이 벽에 쌓여 있다' → 의자가 있지만 벽에 쌓여 있지 않음",
  },
  {
    questionNumber: 36,
    choices: {
      A: "All the desks are occupied.",
      B: "A stack of documents is scattered on the desks.",
      C: "Partitions separate the workstations.",
      D: "Several chairs are placed against the wall.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '파티션이 업무공간을 구분하고 있다' → 사진 속 책상들이 파티션으로 구분되어 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '모든 책상이 사용 중이다' → 책상이 있지만 직원들이 없음,\n\n(B) '서류 뭉치가 책상 위에 흩어져 있다' → 책상 위가 깨끗하고 서류가 흩어져 있지 않음,\n\n(D) '여러 개의 의자가 벽을 따라 놓여있다' → 의자가 벽을 따라 배치된 것이 아니라 책상에 놓여 있음",
  },
  {
    questionNumber: 37,
    choices: {
      A: "The computers are being used.",
      B: "The office is empty.",
      C: "Dividers separate the individual workstations.",
      D: "A pile of documents is stacked on the desks.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '디바이더가 개별 워크스테이션을 구분하고 있다' → 사진 속 책상들이 디바이더로 구분되어 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '컴퓨터가 사용되고 있다' → 컴퓨터가 책상 위에 있지만 사용하는 사람이 없음,\n\n(B) '사무실이 비어있다' → 직원은 없지만 책상과 의자가 배치되어 있어 완전히 비어있지 않음,\n\n(D) '서류 더미가 책상 위에 쌓여있다' → 책상 위에 컴퓨터는 있지만 서류 더미는 없음",
  },
  {
    questionNumber: 38,
    choices: {
      A: "Some people are sitting around the table.",
      B: "A laptop is open on the desk.",
      C: "The glass wall is covered with a curtain.",
      D: "Shadows from the blinds are cast on the floor.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '블라인드로 인한 그림자가 바닥에 드리워져 있다' → 사진 속 블라인드의 그림자가 바닥에 드리워져 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '몇 명의 사람들이 테이블에 앉아 있다' → 책상과 의자는 있지만 사람이 없음,\n\n(B) '노트북이 책상 위에 열려있다' → 책상은 있지만 노트북이 보이지 않음,\n\n(C) '유리벽이 커튼으로 가려져 있다' → 유리벽이 있지만 커튼이 아닌 블라인드가 설치되어 있음",
  },
  {
    questionNumber: 39,
    choices: {
      A: "The desk is cluttered with office supplies.",
      B: "A cup of coffee has been spilled on the desk.",
      C: "All the pens are neatly placed in a holder.",
      D: "A laptop screen is displaying a spreadsheet.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '책상이 사무용품으로 어지럽혀져 있다' → 사진 속 책상이 사무용품으로 어지럽혀져 있으므로 유일한 정답\n\n오답 설명:\n\n(B) '커피가 책상 위에 쏟아져 있다' → 책상 위에 커피잔이 있지만 커피가 쏟아진 모습은 없음,\n\n(C) '모든 펜이 펜꽂이에 깔끔하게 정리되어 있다' → 펜들이 책상 위에 흩어져 있고 펜꽂이가 보이지 않음,\n\n(D) '노트북 화면에 스프레드시트가 표시되어 있다' → 노트북이 있지만 화면이 꺼져 있거나 내용이 보이지 않음",
  },
  {
    questionNumber: 40,
    choices: {
      A: "A person is organizing documents on the desk.",
      B: "Some binders are neatly arranged on a shelf.",
      C: "Several stacks of papers have been piled up on the desk.",
      D: "A pile of books is placed on the floor.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '여러 더미의 서류가 책상 위에 쌓여있다' → 책상 위에 서류 더미가 쌓여있으므로 유일한 정답\n\n오답 설명:\n\n(A) '한 사람이 책상 위에서 서류를 정리하고 있다' → 서류는 있지만 정리하는 사람이 없음,\n\n(B) '바인더가 책장에 깔끔하게 정리되어 있다' → 서류는 있지만 책장에 정리된 바인더는 없음,\n\n(D) '책 더미가 바닥에 놓여있다' → 서류 더미는 있지만 바닥에 놓인 책은 없음",
  },
];
